var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorActiveCheckboxSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon error-active-checkbox-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#e0272a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.624 3.67a.5.5 0 01.805.586l-.053.073-7 8a.5.5 0 01-.657.085l-.073-.06-3-3a.501.501 0 01.638-.765l.07.057 2.621 2.622 6.649-7.597z"
  })));
}

export default SvgErrorActiveCheckboxSv;